export const featurePermissions = [
  {
    sectionDetails: {
      featureKey: "Home",
      name: "home",
      innerPages: ["home"],
      href: "/",
      labelName: "Home",
      needPermission: false,
      adminOrHigherRequired: false,
    },
    hasSubPages: false,
  },
  {
    sectionDetails: {
      featureKey: "Banner",
      name: "banners",
      innerPages: ["banners", "banner_new"],
      labelName: "Banners",
      needPermission: true,
      adminOrHigherRequired: false,
    },
    hasSubPages: false,
  },
  {
    sectionDetails: {
      featureKey: "Notification",
      name: "notifications",
      innerPages: ["notifications", "notification_new"],
      labelName: "Notifications",
      needPermission: true,
      adminOrHigherRequired: false,
    },
    hasSubPages: false,
  },
  {
    sectionDetails: {
      featureKey: "Promotion",
      name: "offers",
      innerPages: ["offers", "offer_new"],
      labelName: "Offers",
      needPermission: true,
      adminOrHigherRequired: false,
    },
    hasSubPages: false,
  },
  {
    sectionDetails: {
      featureKey: "Sypi S3",
      name: "sypiv2",
      labelName: "SyPI",
      needPermission: true,
      adminOrHigherRequired: false,
    },
    subPages: [
      {
        featureKey: "Sypi S3",
        name: "sypi-config-schedule",
        innerPages: ["sypi-config-schedule"],
        labelName: "Schedule",
        needPermission: true,
        adminOrHigherRequired: false,
      },
      {
        featureKey: "Sypi S3",
        name: "sypi-content",
        innerPages: ["sypi-content"],
        labelName: "Content",
        needPermission: true,
        adminOrHigherRequired: false,
      },
      {
        featureKey: "Sypi S3",
        name: "sypi-style",
        innerPages: ["sypi-style"],
        labelName: "Style",
        needPermission: true,
        adminOrHigherRequired: false,
      },
      {
        featureKey: "Sypi S3",
        name: "sypi-feature",
        innerPages: ["sypi-feature"],
        labelName: "Features",
        needPermission: true,
        adminOrHigherRequired: false,
      },
      {
        featureKey: "Sypi S3",
        name: "sypi-import",
        innerPages: ["sypi-import"],
        labelName: "Import",
        needPermission: true,
        adminOrHigherRequired: true,
      },
      {
        featureKey: "Sypi S3",
        name: "sypi-business-rules",
        innerPages: ["sypi-business-rules"],
        labelName: "Business Rules",
        needPermission: true,
        adminOrHigherRequired: true,
      },
      {
        featureKey: "Sypi S3",
        name: "sypi-instance",
        innerPages: ["sypi-instance"],
        labelName: "Instances",
        needPermission: true,
        adminOrHigherRequired: false,
      },
    ],
    hasSubPages: true,
  },
  {
    sectionDetails: {
      featureKey: "Sypi DB",
      name: "sypi-legacy",
      innerPages: ["sypi-legacy"],
      href: "/sypi-legacy",
      labelName: "SyPI Legacy",
      needPermission: true,
      adminOrHigherRequired: false,
    },
    hasSubPages: false,
  },
  {
    sectionDetails: {
      featureKey: "Schema Management",
      name: "schema-management",
      labelName: "Schema Management",
      subFeatures: true,
      needPermission: true,
      adminOrHigherRequired: false,
    },
    subPages: [
      {
        featureKey: "Schema Management",
        subFeatureKey: "syf_card_access",
        name: "schema-management-syf-card-access-config-schedule",
        labelName: "Schedule",
        innerPages: ["schema-management-syf-card-access-config-schedule"],
        href: "/schema-management-syf-card-access-config-schedule",
        needPermission: true,
        adminOrHigherRequired: true,
      },
      {
        featureKey: "Schema Management",
        subFeatureKey: "syf_card_access",
        name: "schema-management-syf-card-access",
        labelName: "Wallets",
        innerPages: ["schema-management-syf-card-access"],
        href: "/schema-management-syf-card-access",
        needPermission: true,
        adminOrHigherRequired: true,
      },
      {
        featureKey: "Schema Management",
        subFeatureKey: "syf_card_access",
        name: "schema-management-syf-card-access-import",
        labelName: "Import",
        innerPages: ["schema-management-syf-card-access-import"],
        href: "/schema-management-syf-card-access-import",
        needPermission: true,
        adminOrHigherRequired: true,
      },
      {
        featureKey: "Schema Management",
        subFeatureKey: "sypi_brc",
        name: "schema-management-sypi-brc-config-schedule",
        innerPages: ["schema-management-sypi-brc-config-schedule"],
        labelName: "Schedule",
        href: "/schema-management-sypi-brc-config-schedule",
        needPermission: true,
        adminOrHigherRequired: false,
      },
      {
        featureKey: "Schema Management",
        subFeatureKey: "sypi_brc",
        name: "schema-management-sypi-brc-content",
        innerPages: ["schema-management-sypi-brc-content"],
        labelName: "Content",
        href: "/schema-management-sypi-brc-content",
        needPermission: true,
        adminOrHigherRequired: false,
      },
      {
        featureKey: "Schema Management",
        subFeatureKey: "sypi_brc",
        name: "schema-management-sypi-brc-styles",
        innerPages: ["schema-management-sypi-brc-styles"],
        labelName: "Style",
        href: "/schema-management-sypi-brc-styles",
        needPermission: true,
        adminOrHigherRequired: false,
      },
      {
        featureKey: "Schema Management",
        subFeatureKey: "sypi_brc",
        name: "schema-management-sypi-brc-features",
        innerPages: ["schema-management-sypi-brc-features"],
        labelName: "Features",
        href: "/schema-management-sypi-brc-features",
        needPermission: true,
        adminOrHigherRequired: false,
      },
      {
        featureKey: "Schema Management",
        subFeatureKey: "sypi_brc",
        name: "schema-management-sypi-brc-import",
        innerPages: ["schema-management-sypi-brc-import"],
        labelName: "Import",
        href: "/schema-management-sypi-brc-import",
        needPermission: true,
        adminOrHigherRequired: true,
      },

      {
        featureKey: "Schema Management",
        subFeatureKey: "sypi_brc",
        name: "schema-management-sypi-brc-business-rules",
        innerPages: ["schema-management-sypi-brc-business-rules"],
        labelName: "Business Rules",
        href: "/schema-management-sypi-brc-business-rules",
        needPermission: true,
        adminOrHigherRequired: true,
      },
      {
        featureKey: "Schema Management",
        subFeatureKey: "rewards_mfe_athos",
        name: "schema-management-rewards-mfe-athos-config-schedule",
        innerPages: ["schema-management-rewards-mfe-athos-config-schedule"],
        labelName: "Schedule",
        href: "/schema-management-rewards-mfe-athos-config-schedule",
        needPermission: true,
        adminOrHigherRequired: true,
      },
      {
        featureKey: "Schema Management",
        subFeatureKey: "rewards_mfe_athos",
        name: "schema-management-rewards-mfe-athos",
        innerPages: ["schema-management-rewards-mfe-athos"],
        labelName: "Rewards MFE",
        href: "/schema-management-rewards-mfe-athos",
        needPermission: true,
        adminOrHigherRequired: true,
      },
      {
        featureKey: "Schema Management",
        subFeatureKey: "rewards_mfe_athos",
        name: "schema-management-rewards-mfe-athos-import",
        innerPages: ["schema-management-rewards-mfe-athos-import"],
        labelName: "Import",
        href: "/schema-management-rewards-mfe-athos-import",
        needPermission: true,
        adminOrHigherRequired: true,
      },
      {
        featureKey: "Schema Management",
        subFeatureKey: "statements_mfe_athos",
        name: "schema-management-statements-mfe-athos-config-schedule",
        innerPages: ["schema-management-statements-mfe-athos-config-schedule"],
        labelName: "Schedule",
        href: "/schema-management-statements-mfe-athos-config-schedule",
        needPermission: true,
        adminOrHigherRequired: false,
      },
      {
        featureKey: "Schema Management",
        subFeatureKey: "statements_mfe_athos",
        name: "schema-management-statements-mfe-athos",
        innerPages: ["schema-management-statements-mfe-athos"],
        labelName: "Statements MFE",
        href: "/schema-management-statements-mfe-athos",
        needPermission: true,
        adminOrHigherRequired: false,
      },
      {
        featureKey: "Schema Management",
        subFeatureKey: "statements_mfe_athos",
        name: "schema-management-statements-mfe-athos-import",
        innerPages: ["schema-management-statements-mfe-athos-import"],
        labelName: "Import",
        href: "/schema-management-statements-mfe-athos-import",
        needPermission: true,
        adminOrHigherRequired: true,
      },
    ],
    hasSubPages: true,
  },
  {
    sectionDetails: {
      name: "integration",
      labelName: "Integration",
      needPermission: false,
      adminOrHigherRequired: false,
    },
    subPages: [
      // { featureKey: 'Store', name: 'stores', innerPages: ['stores', 'store_new', 'location_groups', 'location_group_new', 'bulk_upload'], labelName: 'Store Locator', needPermission: true, adminOrHigherRequired: false },
      // { featureKey: 'Social Feeds', name: 'social-settings', innerPages: ['social-settings'], labelName: 'social', href: '/social-settings', needPermission: true, adminOrHigherRequired: false },
      // { featureKey: 'AbandonedCartRecovery', name: 'cart-recovery', innerPages: ['cart-recovery'], href: '/cart-recovery', labelName: 'Cart Recovery', needPermission: true, adminOrHigherRequired: false },
    ],
    hasSubPages: true,
  },
  {
    sectionDetails: {
      featureKey: "File Manager 3",
      name: "filemanager",
      href: "/files",
      labelName: "File Manager",
      needPermission: true,
      adminOrHigherRequired: false,
    },
    subPages: [
      {
        featureKey: "File Manager 3",
        name: "filemanager",
        labelName: "File Upload",
        innerPages: ["filemanager", "filemanager_new"],
        href: "/filemanager",
      },
      {
        featureKey: "File Manager 3",
        name: "import-assets",
        labelName: "Import Assets",
        innerPages: ["filemanager-import-assets"],
        href: "/filemanager-import-assets",
      },
    ],
    hasSubPages: true,
  },
  {
    sectionDetails: {
      name: "tools",
      labelName: "Tools",
      needPermission: false,
      adminOrHigherRequired: false,
    },
    subPages: [
      {
        featureKey: "Sypi File Manager",
        name: "files",
        innerPages: ["files", "file_new"],
        href: "/files",
        labelName: "Sypi File Manager",
        needPermission: true,
        adminOrHigherRequired: false,
      },
      {
        featureKey: "Notification",
        name: "pn-testing",
        innerPages: ["pn-testing"],
        href: "/pn-testing",
        labelName: "PN Testing",
        needPermission: true,
        adminOrHigherRequired: false,
      },
      {
        featureKey: "Debug",
        name: "build-details",
        innerPages: ["build-details"],
        href: "/build-details",
        labelName: "Debug",
        needPermission: true,
        adminOrHigherRequired: true,
      },
    ],
    hasSubPages: true,
  },
  {
    sectionDetails: {
      featureKey: "C3",
      name: "c3",
      labelName: "C3 Client Admin",
      needPermission: true,
      adminOrHigherRequired: true,
      superAdmin: true,
    },
    subPages: [
      {
        featureKey: "C3",
        name: "c3-clients",
        labelName: "Clients",
        innerPages: ["c3-clients", "client_new"],
        href: "/c3-clients",
      },
      {
        featureKey: "C3",
        name: "c3-client-groups",
        labelName: "Client Groups",
        innerPages: ["c3-client-groups", "client_group_new"],
        href: "/c3-client-groups",
      },
    ],
    hasSubPages: true,
  },
];
export const exemptPages = { C3: "rw", "DTP Maintenance Mode": "rw"  };
export const schemaLabels = {
  syf_card_access: "Syf Card Access",
  sypi_brc: "SyPI BRC",
  rewards_mfe_athos: "Athos MFE",
  statements_mfe_athos: "Athos MFE",
};
export const isURLAValidPage = (currentPage) => {
  let page = { page: "home", subPage: "" };
  if (!(!currentPage || (currentPage && !currentPage.length))) {
    featurePermissions.forEach((feature) => {
      page = feature.hasSubPages
        ? feature.subPages.reduce((acc, subPage) => {
            if (subPage.innerPages.includes(currentPage)) {
              acc = {
                page: feature.sectionDetails.name,
                subPage: subPage.name,
              };
            }
            return acc;
          }, page)
        : feature.sectionDetails.innerPages.includes(currentPage)
        ? { page: feature.sectionDetails.name, subPage: "" }
        : page;
    });
  }
  return page;
};

export const getMainPagesRoutes = (contextName, featurePermissions) => {
  // const featureName = featurePermissions.find((feature) => {
  //   if (feature?.hasSubPages) {
  //     return feature.subPages.some((subPage) => {
  //       return subPage.innerPages.includes(contextName);
  //     });
  //   } else {
  //     return feature?.sectionDetails?.innerPages.includes(contextName);
  //   }
  // });
  // return featureName
  const mainPages = featurePermissions.reduce((acc, feature) => {
    if (feature?.hasSubPages) {
      feature.subPages.forEach((subPage) => {
        acc[subPage.name] = [...(subPage?.innerPages || [])];
      });
      acc[feature.sectionDetails.name] = [...feature.subPages.reduce((accSub, subPage) => {
        accSub = [...accSub, ...subPage?.innerPages];
        return accSub;
      }, [])];
    } else {
      acc[feature.sectionDetails.name] = [...feature?.sectionDetails?.innerPages]
    }
    return acc;
  }, {});
  return mainPages
};

export const mainPagesRoutes = {
  home: ["home"],
  banners: ["banners", "banner_new"],
  notifications: ["notifications", "notification_new"],
  promotions: ["promotions", "promotion_new"],
  sypi: [
    "sypi-config-schedule",
    "sypi-content",
    "sypi-style",
    "sypi-feature",
    "sypi-import",
    "sypi-business-rules",
    "sypi-server-setting",
    "sypi-db-configs",
  ],
  files: ["files", "file_new"],
  "pn-testing": ["pn-testing"],
  "build-details": ["build-details"],
  c3: [
    "c3-client-groups",
    "c3-clients",
    "client_group_new",
    "client_new",
  ],
};
